import type { ThemeMode } from '@constants/colors';

/** Translation key of each selectable theme's display name. */
export const THEME_LABEL_KEY: Partial<Record<ThemeMode, string>> = {
  jarvis: 'theme.jarvis',
  'jarvis-night': 'theme.jarvisNight',
  horizon: 'theme.horizon',
  'horizon-night': 'theme.horizonNight',
  dawn: 'theme.horizonDawn',
  dusk: 'theme.horizonDusk',
  mist: 'theme.horizonMist',
};
